(function() {
  function disableThemeStickyAtc() {
    document.querySelectorAll('.sticky-add-to-cart, #md-sticky-atc').forEach(function(sticky) {
      sticky.style.setProperty('display', 'none', 'important');
      sticky.classList.remove('sticky-show', 'show');
      sticky.setAttribute('aria-hidden', 'true');
    });
  }

  function initBundlePdp(root) {
    disableThemeStickyAtc();

    var variantInput = root.querySelector('[data-variant-id]');
    var price = root.querySelector('[data-price]');
    var compare = root.querySelector('[data-compare]');
    var save = root.querySelector('[data-save]');
    var mobilePrice = root.querySelector('[data-mobile-price]');
    var addButtons = root.querySelectorAll('[data-add-button]');
    var qtyInput = root.querySelector('[data-qty-input]');
	    var paymentTermsVariantInput = root.querySelector('[data-payment-terms-variant-id]');
	    var productForm = root.querySelector('.wb-form');
	    var bundleKey = root.getAttribute('data-bundle-key') || 'everyday';
	    var initialColorIndex = parseInt(root.getAttribute('data-initial-color-index') || '0', 10);
	    var productDataEl = root.querySelector('[data-bundle-product-json]');
	    var inventoryDataEl = root.querySelector('[data-bundle-inventory-json]');
	    var productData = null;
	    var inventoryData = {};
	    try {
	      productData = productDataEl ? JSON.parse(productDataEl.textContent) : null;
	    } catch (error) {
	      productData = null;
	    }
	    try {
	      inventoryData = inventoryDataEl ? JSON.parse(inventoryDataEl.textContent) : {};
	    } catch (error) {
	      inventoryData = {};
	    }
	    var cdn = 'https://cdn.shopify.com/s/files/1/0561/5891/2694/files/';
    var layerUrls = {
      canopy_left: [
        cdn + 'canopy-left-midnight-black.png',
        cdn + 'canopy-left-forest-green.png',
        cdn + 'canopy-left-mocha.png'
      ],
      canopy_right: [
        cdn + 'canopy-right-midnight-black.png',
        cdn + 'canopy-right-forest-green.png',
        cdn + 'canopy-right-mocha.png'
      ],
      basket_left: [
        cdn + 'basket-left-midnight-black.png',
        cdn + 'basket-left-forest-green.png',
        cdn + 'basket-left-mocha.png'
      ],
      basket_right: [
        cdn + 'basket-right-midnight-black.png',
        cdn + 'basket-right-forest-green.png',
        cdn + 'basket-right-mocha.png'
      ],
      snack: cdn + 'snack-tray-both.png',
      bugnet: {
        '0_0': cdn + 'Customize_bugnet_double_B_ac608867-9214-4153-b5fd-d19a02a80a7f.png',
        '1_1': cdn + 'Customize_bugnet_double_G.png',
        '2_2': cdn + 'Customize_bugnet_double_M.png'
      },
      rainfly: {
        '0_0': cdn + 'Customize_rainfly_double_B_a1aebe1f-e7d3-4bf6-a671-67c8a4b1f5bb.png',
        '1_1': cdn + 'Customize_rainfly_double_G.png',
        '2_2': cdn + 'Customize_rainfly_double_M.png'
      }
	    };
	    var labels = ['Midnight Black', 'Moss Green', 'Mocha'];
	    var selectedOptions = {};
	    if (initialColorIndex < 0 || initialColorIndex >= labels.length) initialColorIndex = 0;
    var layers = {
      canopy_left: root.querySelector('[data-bundle-layer="canopy_left"]'),
      canopy_right: root.querySelector('[data-bundle-layer="canopy_right"]'),
      basket_left: root.querySelector('[data-bundle-layer="basket_left"]'),
      basket_right: root.querySelector('[data-bundle-layer="basket_right"]'),
      snack: root.querySelector('[data-bundle-layer="snack"]'),
      bugnet: root.querySelector('[data-bundle-layer="bugnet"]'),
      rainfly: root.querySelector('[data-bundle-layer="rainfly"]')
    };

    function setLayer(name, src) {
      var layer = layers[name];
      if (!layer) return;
      if (src) {
        layer.src = src;
        layer.hidden = false;
      } else {
        layer.removeAttribute('src');
        layer.hidden = true;
      }
    }

    function setProperty(name, value) {
      var input = root.querySelector('[data-bundle-property="' + name + '"]');
      if (input) input.value = value;
    }

	    function setOptionValue(name, value) {
	      var label = root.querySelector('[data-bundle-option-value="' + name + '"]');
	      if (label) label.textContent = value;
	    }

	    function normalizeOptionValue(value) {
	      var normalized = String(value || '').toLowerCase().trim();
	      if (normalized.indexOf('black') !== -1 || normalized.indexOf('midnight') !== -1) return 'black';
	      if (normalized.indexOf('green') !== -1 || normalized.indexOf('moss') !== -1 || normalized.indexOf('forest') !== -1) return 'green';
	      if (normalized.indexOf('mocha') !== -1) return 'mocha';
	      return normalized;
	    }

	    function activeOptionValues() {
	      var values = [];
	      if (/everyday|daily|snack|loaded/.test(bundleKey)) {
	        values.push(selectedOptions.canopy_all || labels[initialColorIndex]);
	      }
	      if (/daily|snack|loaded/.test(bundleKey)) {
	        values.push(selectedOptions.basket_all || selectedOptions.canopy_all || labels[initialColorIndex]);
	      }
	      return values.map(normalizeOptionValue);
	    }

	    function selectedBundleVariant() {
	      if (!productData || !productData.variants || !productData.variants.length) return null;
	      if (bundleKey === 'base') return withInventory(productData.variants.find(function(variant) { return variant.available; }) || productData.variants[0]);
	      var expectedOptions = activeOptionValues();
	      if (!expectedOptions.length) return withInventory(productData.variants.find(function(variant) { return variant.available; }) || productData.variants[0]);
	      var matchedVariant = productData.variants.find(function(variant) {
	        if (!variant.available || !variant.options) return false;
	        return expectedOptions.every(function(expectedValue, index) {
	          return normalizeOptionValue(variant.options[index]) === expectedValue;
	        });
	      }) || productData.variants.find(function(variant) { return variant.available; }) || productData.variants[0];
	      return withInventory(matchedVariant);
	    }

	    function withInventory(variant) {
	      if (!variant) return variant;
	      var variantInventory = inventoryData[String(variant.id)];
	      return variantInventory ? Object.assign({}, variant, variantInventory) : variant;
	    }

	    function isBackorderedVariant(variant) {
	      if (!variant || !variant.available) return false;
	      if (!variant.inventory_management) return false;
	      return Number(variant.inventory_quantity || 0) < 1;
	    }

    function updateBackorderMessage(variant) {
      var backorder = root.querySelector('.backorder');
      if (!backorder) return;
	      var variantLabel = backorder.querySelector('.backorder__variant');
	      if (variantLabel && productData) {
	        variantLabel.textContent = productData.title + (variant && variant.title && variant.title.indexOf('Default') === -1 ? ' - ' + variant.title : '');
	      }
	      var backordered = isBackorderedVariant(variant);
      backorder.classList.toggle('hidden', !backordered);
      backorder.style.display = backordered ? '' : 'none';
    }

    function formatBundleMoney(cents) {
      if (window.theme && window.theme.Shopify && typeof window.theme.Shopify.formatMoney === 'function') {
        return window.theme.Shopify.formatMoney(cents, root.getAttribute('data-money-format') || undefined).replace(/\.00\b/g, '');
      }
      return '$' + (Number(cents || 0) / 100).toFixed(0);
    }

    function updateVariantPricing(variant) {
      if (!variant) return;
      if (price) price.textContent = formatBundleMoney(variant.price);
      if (mobilePrice) mobilePrice.textContent = formatBundleMoney(variant.price);
      if (!compare || !save) return;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.hidden = false;
        save.hidden = false;
        compare.textContent = formatBundleMoney(variant.compare_at_price);
        save.textContent = 'Save ' + formatBundleMoney(variant.compare_at_price - variant.price);
      } else {
        compare.hidden = true;
        save.hidden = true;
        compare.textContent = '';
        save.textContent = '';
      }
    }

	    function updateSelectedVariant() {
	      var variant = selectedBundleVariant();
	      if (!variant) return;
	      if (variantInput) variantInput.value = variant.id;
	      if (paymentTermsVariantInput) paymentTermsVariantInput.value = variant.id;
	      updateVariantPricing(variant);
	      setAddState(variant.available);
	      updateBackorderMessage(variant);
	    }

    function setLoadedWeatherLayers(index) {
      var key = index + '_' + index;
      setLayer('bugnet', layerUrls.bugnet[key]);
      setLayer('rainfly', layerUrls.rainfly[key]);
    }

	    function applyBundleChoice(apply, index, label) {
	      if (apply === 'canopy_left') {
	        setLayer('canopy_left', layerUrls.canopy_left[index]);
	        setProperty('canopy_left', label);
	        selectedOptions.canopy_all = label;
	      }

	      if (apply === 'canopy_right') {
	        setLayer('canopy_right', layerUrls.canopy_right[index]);
	        setProperty('canopy_right', label);
	        selectedOptions.canopy_all = label;
	      }

	      if (apply === 'canopy_all') {
	        setLayer('canopy_left', layerUrls.canopy_left[index]);
	        setLayer('canopy_right', layerUrls.canopy_right[index]);
	        setProperty('canopy_all', label);
	        selectedOptions.canopy_all = label;
	        if (bundleKey === 'loaded') setLoadedWeatherLayers(index);
	      }

	      if (apply === 'basket_left') {
	        setLayer('basket_left', layerUrls.basket_left[index]);
	        setProperty('basket_all', label);
	        selectedOptions.basket_all = label;
	      }

	      if (apply === 'basket_all') {
	        setLayer('basket_left', layerUrls.basket_left[index]);
	        setLayer('basket_right', layerUrls.basket_right[index]);
	        setProperty('basket_all', label);
	        selectedOptions.basket_all = label;
	      }
	    }

    function setActiveBundleSwatch(group, index) {
      root.querySelectorAll('[data-bundle-group="' + group + '"]').forEach(function(item) {
        var isActive = parseInt(item.getAttribute('data-bundle-index') || '0', 10) === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function initBundleLayers() {
      var label = labels[initialColorIndex];

      if (bundleKey === 'everyday') {
        setActiveBundleSwatch('canopy_all', initialColorIndex);
        applyBundleChoice('canopy_all', initialColorIndex, label);
      }

      if (bundleKey === 'daily') {
        setActiveBundleSwatch('canopy_all', initialColorIndex);
        setActiveBundleSwatch('basket_all', initialColorIndex);
        applyBundleChoice('canopy_all', initialColorIndex, label);
        applyBundleChoice('basket_left', initialColorIndex, label);
      }

      if (bundleKey === 'snack') {
        setActiveBundleSwatch('canopy_all', initialColorIndex);
        setActiveBundleSwatch('basket_all', initialColorIndex);
        applyBundleChoice('canopy_all', initialColorIndex, label);
        applyBundleChoice('basket_left', initialColorIndex, label);
        setLayer('snack', layerUrls.snack);
      }

      if (bundleKey === 'loaded') {
        setActiveBundleSwatch('canopy_all', initialColorIndex);
        setActiveBundleSwatch('basket_all', initialColorIndex);
        applyBundleChoice('canopy_all', initialColorIndex, label);
        applyBundleChoice('basket_all', initialColorIndex, label);
        setLayer('snack', layerUrls.snack);
        setLoadedWeatherLayers(initialColorIndex);
      }
    }

    function setAddState(available) {
      addButtons.forEach(function(button) {
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      });
    }

    function openCartDrawer() {
      document.documentElement.dispatchEvent(
        new CustomEvent('theme:cartchanged', {
          bubbles: true,
          cancelable: false,
          detail: { openDrawer: true }
        })
      );
    }

    if (productForm) {
      productForm.addEventListener('submit', function(event) {
        if (!window.theme || !window.theme.routes || !window.theme.routes.cart_add_url) return;

        event.preventDefault();

        var submitButton = productForm.querySelector('[data-add-button]');
        if (submitButton) submitButton.disabled = true;

        fetch(window.theme.routes.cart_add_url, {
          method: 'POST',
          body: new FormData(productForm),
          headers: {
            Accept: 'application/json'
          }
        })
        .then(function(response) {
          if (!response.ok) return response.json().then(function(error) { throw error; });
          return response.json();
        })
        .then(openCartDrawer)
        .catch(function(error) {
          var message = error && (error.description || error.message) ? (error.description || error.message) : 'Unable to add item to cart.';
          if (window.theme && typeof window.theme.showQuickPopup === 'function' && submitButton && window.jQuery) {
            window.theme.showQuickPopup(message, window.jQuery(submitButton), 'error');
          } else {
            window.alert(message);
          }
        })
        .finally(function() {
          if (submitButton) submitButton.disabled = false;
        });
      });
    }

    root.querySelectorAll('[data-variant-option]').forEach(function(button) {
      button.addEventListener('click', function() {
        root.querySelectorAll('[data-variant-option]').forEach(function(item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');

        if (variantInput) variantInput.value = button.getAttribute('data-variant-id-value');
        if (paymentTermsVariantInput) paymentTermsVariantInput.value = button.getAttribute('data-variant-id-value');
        if (price) price.textContent = button.getAttribute('data-price-value');
        if (mobilePrice) mobilePrice.textContent = button.getAttribute('data-price-value');

        if (compare && save) {
          if (button.getAttribute('data-compare-value')) {
            compare.hidden = false;
            save.hidden = false;
            compare.textContent = button.getAttribute('data-compare-value');
            save.textContent = button.getAttribute('data-save-value');
          } else {
            compare.hidden = true;
            save.hidden = true;
            compare.textContent = '';
            save.textContent = '';
          }
        }

        setAddState(button.getAttribute('data-available') === 'true');
      });
    });

    root.querySelectorAll('[data-bundle-swatch]').forEach(function(button) {
      button.addEventListener('click', function() {
        var group = button.getAttribute('data-bundle-group');
        var apply = button.getAttribute('data-bundle-apply');
        var index = parseInt(button.getAttribute('data-bundle-index') || '0', 10);
        var label = button.getAttribute('data-bundle-label') || labels[index] || '';

        root.querySelectorAll('[data-bundle-group="' + group + '"]').forEach(function(item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');

	        setOptionValue(group, label);
	        applyBundleChoice(apply, index, label);
	        updateSelectedVariant();
	      });
	    });

    root.querySelector('[data-qty-minus]')?.addEventListener('click', function() {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
    });

    root.querySelector('[data-qty-plus]')?.addEventListener('click', function() {
      if (!qtyInput) return;
      qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
    });

	    initBundleLayers();
	    updateSelectedVariant();
	  }

  document.querySelectorAll('.jci-waggle-bundle').forEach(initBundlePdp);

  window.addEventListener('scroll', disableThemeStickyAtc, { passive: true });
})();
